module.exports = __webpack_public_path__ + "img/close-L-gray.15193b62.svg";